var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('k-form-design',{ref:"kfd",attrs:{"toolbars":_vm.toolbars,"toolbarsTop":"","showToolbarsText":""},on:{"close":_vm.handleClose,"save":_vm.handleSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }